import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo-2.svg'
import { useFetch } from '../../hooks/useFetch'
import { useTranslation } from 'react-i18next'
import { fetchContact, fetchprojects, fetchServices } from '../../api/api'

const Footer = (props) => {
    const { t } = useTranslation();

    const { data: services } = useFetch(["services"], fetchServices);
    const { data: contact } = useFetch(["contact"], fetchContact);
    const { data: projects } = useFetch(["projects"], fetchprojects);
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <footer className={`wpo-site-footer ${props.ftClass}`}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <Link onClick={ClickHandler} className="logo" to="/"><img src={Logo} alt="" /></Link>
                                </div>
                                <p>{t('footer.aboutText')}</p>
                                <ul>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-facebook"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-twitter-alt"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-google"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.servicesTitle')}</h3>
                                </div>
                                <ul>
                                    {services?.data?.data?.slice(0, 3).map((service, Sitem) => (
                                        <li key={Sitem}>
                                            <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>
                                                {service?.data?.title}
                                            </Link>
                                        </li>
                                    ))}
                                    <li>
                                        <Link onClick={ClickHandler} to="/service">
                                            {t('footer.seeMore')}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.contactTitle')}</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        {/* Address */}
                                        <li>
                                            <i className="fi flaticon-location"></i>
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contact?.data?.contact?.firstAddress)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {contact?.data?.contact?.firstAddress}
                                            </a>
                                        </li>

                                        {/* Phone Number */}
                                        <li>
                                            <i className="fi flaticon-telephone"></i>
                                            <a href={`tel:${contact?.data?.contact?.firstPhoneNumber}`}>
                                                {contact?.data?.contact?.firstPhoneNumber}
                                            </a>
                                        </li>

                                        {/* Email */}
                                        <li>
                                            <i className="fi flaticon-email"></i>
                                            <a href={`mailto:${contact?.data?.contact?.firstEmail}`}>
                                                {contact?.data?.contact?.firstEmail}
                                            </a>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget instagram">
                                <div className="widget-title">
                                    <h3>{t('footer.galleryTitle')}</h3>
                                </div>
                                <ul className="d-flex">
                                    {projects?.data?.data?.slice(0, 6).map((project, pot) => (
                                        <li key={pot}>  <Link onClick={ClickHandler} to={`/project-single/${project.id}`}><img src={`${process.env.REACT_APP_API_URL}/api/images/${project?.data?.thumbnail}`} alt="" /></Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>
                                    &copy; 2024 AlRiyada. {t('footer.by')}{' '}
                                    <a href="https://Nexlla.com" target="_blank" rel="noopener noreferrer" onClick={ClickHandler}>
                                        Nexlla CA
                                    </a>
                                    {" " + t('footer.allRightsReserved')}
                                </li>
                                <li><Link onClick={ClickHandler} to="/terms">{t('footer.termsOfUse')} |</Link> <Link onClick={ClickHandler} to="/privacy">{t('footer.privacyPolicy')}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
